import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

export default function(Vue) {
  if (!process.env.VUE_APP_SENTRY_DSN) {
    return;
  }

  const sentryConfig = {
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
        logErrors: process.env.NODE_ENV !== "production",
      }),
    ],
  };

  if (process.env.SENTRY_VERSION) {
    sentryConfig.release = process.env.SENTRY_VERSION;
  }

  if (process.env.NODE_ENV) {
    sentryConfig.environment = process.env.NODE_ENV;
  }

  Sentry.init(sentryConfig);
}
